import React, { Dispatch, SetStateAction } from 'react';
import useMyOrdersHeader from './myOrdersHeader-hook';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import { IBusinessProfile, IServices } from '../../../../../../../../Interfaces/responseTypes';
import { DrawerOpenSides } from '../../../../../../../../Interfaces/componentTypes';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';
import { MenuIcon, SettingIcon } from '../../../../../../../../Components/IconComponents';
import { VisitorPageContents } from '../../../../../visitorPage';
import CustomDialog from '../../../../../../../../Components/Dialog/customDialog';
import CustomDrawer from '../../../../../../../../Components/Drawer/CustomDrawer/customDrawer';
import MainLogo from '../../../../../../../../Components/Logos/mainLogo/mainLogo';
import styles from './myOrdersHeader.module.scss';

export interface IMyOrdersHeaderProps {
    logo: string,
    business_profile?: IBusinessProfile,
    companyId: number,
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
    is_user: boolean,
    services: IServices | null,
    onOpenReserveDialog: () => void
}

const MyOrdersHeader: React.FC<IMyOrdersHeaderProps> = (props) => {
    const { business_profile, services } = props;
    const { mobileScreen, } = useNoAuthHooks();
    const { t } = useLanguagesHooks();
    const {
        open,
        openDrawer,
        dialogComponent,
        drawercomponent,
        onClose,
        onOpenMenuDrawer,
        onOpenSettingDialog,
        onCloseHeaderDrawer,
    } = useMyOrdersHeader(props);

    return (
        <div className={styles.header} >
            <MainLogo />
            <p className={`${styles.title}`}>
                {t('Visitor.My_Orders')}
            </p>
            <div className={styles.navBox}>
                {
                    business_profile && !mobileScreen
                        ?
                        <div className={styles.menuIcon}>
                            <MenuIcon color='var(--icon-color)' width={23} height={23} onClick={onOpenMenuDrawer} />
                        </div>
                        :
                        (
                            services?.reserve
                                ?
                                <div className={styles.headerIcon}>
                                    <MenuIcon onClick={onOpenMenuDrawer} color="var(--icon-color)" width={23} height={23} />
                                </div>
                                :
                                <div className={styles.headerIcon}>
                                    <SettingIcon onClick={onOpenSettingDialog} color="var(--icon-color)" />
                                </div>
                        )
                }
            </div>
            <CustomDialog
                open={open}
                onClose={onClose}
                children={dialogComponent}
            />
            <CustomDrawer
                openSide={DrawerOpenSides.Right}
                children={drawercomponent}
                open={openDrawer}
                onClose={onCloseHeaderDrawer}
            />
        </div>
    )
}

export default MyOrdersHeader
